import type { TableSortValue } from "@src/shared/constants/sort-order.constants";
import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export interface EducationalContent {
  id: string | number;
  title: string;
  description?: string | null;
  contentType: string;
  fileType: string;
  fileUrl: string;
  status: string;
}

export interface AddEducationalContent {
  title: string;
  description?: string;
  contentType?: string;
  fileType: string;
  fileUrl: string;
  status?: string;
}

export interface GetEducationalParams {
  page?: number;
  pageSize?: number;
  title?: string;
  contentType?: string;
  fileType?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: TableSortValue;
  [key: string]: unknown;
}

export class EducationalService {
  async getEducationalContent(query?: GetEducationalParams) {
    return apiService.get("/educational", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getEducationalContentDetails(id: string | number) {
    return apiService.get(`/educational/${id}`);
  }

  async addEducationalContent(data: AddEducationalContent) {
    return apiService.post("/educational", data);
  }

  async updateEducationalContent(
    id: string | number,
    data: Partial<AddEducationalContent>
  ) {
    return apiService.put(`/educational/${id}`, data);
  }

  async deleteEducationalContent(id: string | number) {
    return apiService.delete(`/educational/${id}`);
  }
}

export const educationalService = new EducationalService();
